import React, { useState } from 'react';
import styled from 'styled-components';
import axios from 'axios';
import logoEdeli from '../assets/img/edeli_store.png';
import { useNavigate, useSearchParams } from 'react-router-dom';

const LoginContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100vw;
  background-color: var(--bg-app);
  transition: background-color 0.3s ease;
  padding: 20px;
  box-sizing: border-box;
  overflow: hidden;

  @media (max-width: 480px) {
    height: auto;
    min-height: 100vh;
    overflow-y: auto;
  }
`;

const LoginCard = styled.div`
  background-color: ${props => props.isDarkMode ? '#2c2c2c' : '#fcfcfc'}; 
  padding: 45px 40px;
  border-radius: 12px;
  box-shadow: ${props => props.isDarkMode 
    ? '0 10px 25px rgba(0, 0, 0, 0.5)' 
    : '0 10px 25px rgba(0, 0, 0, 0.1)'};
  border: 1px solid ${props => props.isDarkMode ? '#3d3d3d' : '#eeeeee'};
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 400px;
  position: relative;
  transition: all 0.3s ease;

  @media (max-height: 700px) and (min-width: 481px) {
    transform: scale(0.9);
  }

  @media (max-width: 480px) {
    padding: 50px 20px 30px 20px;
  }
`;

const DashboardHomeButton = styled.button`
  position: absolute;
  top: 15px;
  left: 15px;
  background: none;
  border: none;
  font-size: 20px;
  color: ${props => props.isDarkMode ? '#ffffff' : '#333333'};
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;
  transition: transform 0.2s ease;
  opacity: 0.8;
  z-index: 10;

  &:hover {
    transform: translateX(-3px);
    opacity: 1;
  }
`;

const LogoImage = styled.img`
  width: 130px;
  height: auto;
  margin-bottom: 20px;
  
  @media (max-width: 480px) {
    width: 110px;
  }
`;

const SwitchContainer = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
`;

const SwitchLabel = styled.span`
  font-size: 11px;
  color: ${props => props.isDarkMode ? '#bbb' : '#666'};
  font-weight: bold;
`;

const ToggleSlot = styled.div`
  position: relative;
  width: 36px;
  height: 18px;
  background-color: ${props => props.active ? '#555' : '#ccc'};
  border-radius: 20px;
`;

const ToggleCircle = styled.div`
  position: absolute;
  top: 2px;
  left: ${props => props.active ? '20px' : '2px'};
  width: 14px;
  height: 14px;
  background-color: white;
  border-radius: 50%;
  transition: left 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 8px;
`;

const LoginForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 15px;
  width: 100%;
`;

const Label = styled.label`
  font-weight: bold;
  color: ${props => props.isDarkMode ? '#ffffff' : '#333'};
  font-size: 14px;
`;

const Input = styled.input`
  padding: 12px;
  border: 1px solid ${props => props.isDarkMode ? '#444' : '#ddd'};
  border-radius: 6px;
  background-color: ${props => props.isDarkMode ? '#3d3d3d' : 'white'};
  color: ${props => props.isDarkMode ? 'white' : '#333'};
  font-size: 16px;
  width: 100%;
  box-sizing: border-box;
  
  &:focus { outline: none; border-color: #007bff; }
`;

// ── Wrapper para el input de contraseña con ojito ──────────────────────────
const PasswordWrapper = styled.div`
  position: relative;
  width: 100%;
`;

const PasswordInput = styled.input`
  padding: 12px 44px 12px 12px;
  border: 1px solid ${props => props.isDarkMode ? '#444' : '#ddd'};
  border-radius: 6px;
  background-color: ${props => props.isDarkMode ? '#3d3d3d' : 'white'};
  color: ${props => props.isDarkMode ? 'white' : '#333'};
  font-size: 16px;
  width: 100%;
  box-sizing: border-box;
  
  &:focus { outline: none; border-color: #007bff; }
`;

const EyeButton = styled.button`
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${props => props.isDarkMode ? '#888' : '#999'};
  font-size: 18px;
  transition: color 0.2s ease;

  &:hover { color: ${props => props.isDarkMode ? '#ccc' : '#555'}; }
`;

const Button = styled.button`
  color: white;
  padding: 14px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-weight: bold;
  font-size: 15px;
  transition: all 0.3s ease;
  
  &:active { transform: scale(0.98); }
`;

const ErrorText = styled.span`
  color: #ff4d4d;
  font-size: 13px;
  text-align: center;
`;

// Styled components
const GoogleBtn = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 12px;
  border-radius: 6px;
  border: 1px solid ${props => props.isDarkMode ? '#444' : '#ddd'};
  background: ${props => props.isDarkMode ? '#2c2c2c' : '#fff'};
  color: ${props => props.isDarkMode ? '#fff' : '#333'};
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  margin-top: 5px;

  &:hover {
    background: ${props => props.isDarkMode ? '#3a3a3a' : '#f5f5f5'};
    border-color: #4285F4;
  }
`;

const GoogleIcon = styled.span`
  display: flex;
  align-items: center;
`;

const Divider = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 4px 0;
`;

const DividerLine = styled.div`
  flex: 1;
  height: 1px;
  background: ${p => p.isDarkMode ? '#3a3a3a' : '#e8e8e8'};
`;

const DividerText = styled.span`
  font-size: 12px;
  color: ${p => p.isDarkMode ? '#555' : '#bbb'};
  white-space: nowrap;
  font-weight: 500;
`;

const RegisterRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin-top: 4px;
`;

const RegisterText = styled.span`
  font-size: 13px;
  color: ${p => p.isDarkMode ? '#666' : '#999'};
`;

const RegisterLink = styled.span`
  font-size: 13px;
  font-weight: 700;
  color: #4f46e5;
  cursor: pointer;
  &:hover { text-decoration: underline; }
`;

// ── Íconos SVG de ojo ──────────────────────────────────────────────────────
const EyeOpen = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
    <circle cx="12" cy="12" r="3"/>
  </svg>
);

const EyeClosed = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/>
    <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/>
    <line x1="1" y1="1" x2="23" y2="23"/>
  </svg>
);

function Login({ onSuccess, toggleTheme, theme }) {
  const [credentials, setCredentials] = useState({ username: '', password: '' });
  const [error, setError] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const isDarkMode = theme === 'dark';

  const [searchParams] = useSearchParams();
  const redirectTo = searchParams.get('redirect');
  const creatorSlug = redirectTo?.startsWith('/creador/') ? redirectTo.split('/creador/')[1] : null;

  const [storeLogo, setStoreLogo] = useState(null);

  React.useEffect(() => {
    if (!creatorSlug) {
      document.title = 'Edeli Store';
      return;
    }
    axios.get(`${process.env.REACT_APP_API_URL}/api/user/store/${creatorSlug}`)
      .then(res => {
        setStoreLogo(res.data.store.logo);
        document.title = res.data.store.name || 'Edeli Store';

        if (res.data.store.logo) {
          let favicon = document.querySelector("link[rel~='icon']");
          if (!favicon) {
            favicon = document.createElement('link');
            favicon.rel = 'icon';
            document.head.appendChild(favicon);
          }
          favicon.href = res.data.store.logo;
        }
      })
      .catch(() => {});
  }, [creatorSlug]);

  const displayLogo = storeLogo || logoEdeli;

  const handleChange = (e) => {
    setCredentials({ ...credentials, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const API_URL = process.env.REACT_APP_API_URL;
      const response = await axios.post(`${API_URL}/api/user/login`, credentials);
      onSuccess(response.data);
      navigate(redirectTo || '/dashboard');
    } catch (err) {
      setError(err.response?.data?.message || 'Error al iniciar sesión');
    }
  };

  // Función
  const handleGoogleLogin = () => {
    const redirectParam = redirectTo ? `?redirect=${encodeURIComponent(redirectTo)}` : '';
    window.location.href = `${process.env.REACT_APP_API_URL}/api/auth/google${redirectParam}`;
  };

  return (
    <LoginContainer>
      <LoginCard isDarkMode={isDarkMode}>
        
        <DashboardHomeButton 
          isDarkMode={isDarkMode} 
          onClick={() => navigate(redirectTo || '/dashboard')}
          title="Ir al Inicio"
          type="button"
        >
          ←
        </DashboardHomeButton>

        <SwitchContainer onClick={toggleTheme}>
          <SwitchLabel isDarkMode={isDarkMode}>{isDarkMode ? 'Oscuro' : 'Claro'}</SwitchLabel>
          <ToggleSlot active={isDarkMode}>
            <ToggleCircle active={isDarkMode}>
              {isDarkMode ? '🌙' : '☀️'}
            </ToggleCircle>
          </ToggleSlot>
        </SwitchContainer>

        <LogoImage src={displayLogo} alt="Logo" />
        
        <LoginForm onSubmit={handleSubmit}>
          <Label isDarkMode={isDarkMode}>Usuario</Label>
          <Input
            isDarkMode={isDarkMode}
            type="text"
            name="username"
            placeholder="Usuario"
            value={credentials.username}
            onChange={handleChange}
            required
          />

          <Label isDarkMode={isDarkMode}>Contraseña</Label>
          <PasswordWrapper>
            <PasswordInput
              isDarkMode={isDarkMode}
              type={showPassword ? 'text' : 'password'}
              name="password"
              placeholder="••••••••"
              value={credentials.password}
              onChange={handleChange}
              required
            />
            <EyeButton
              type="button"
              isDarkMode={isDarkMode}
              onClick={() => setShowPassword(prev => !prev)}
            >
              {showPassword ? <EyeOpen /> : <EyeClosed />}
            </EyeButton>
          </PasswordWrapper>

          {error && <ErrorText>{error}</ErrorText>}

          <Button 
            style={{ background: 'linear-gradient(135deg, #4f46e5, #7c3aed)' }} 
            type="submit"
          >
            Iniciar Sesión
          </Button>

          {/* Separador */}
          <Divider isDarkMode={isDarkMode}>
            <DividerLine isDarkMode={isDarkMode} />
            <DividerText isDarkMode={isDarkMode}>o continúa con</DividerText>
            <DividerLine isDarkMode={isDarkMode} />
          </Divider>

          <GoogleBtn type="button" isDarkMode={isDarkMode} onClick={handleGoogleLogin}>
            <GoogleIcon>
              <svg width="18" height="18" viewBox="0 0 48 48">
                <path fill="#EA4335" d="M24 9.5c3.14 0 5.95 1.08 8.17 2.85l6.08-6.08C34.46 3.05 29.5 1 24 1 14.82 1 7.07 6.48 3.64 14.26l7.08 5.5C12.4 13.6 17.73 9.5 24 9.5z"/>
                <path fill="#4285F4" d="M46.1 24.5c0-1.64-.15-3.22-.42-4.74H24v8.98h12.42c-.54 2.9-2.18 5.36-4.64 7.02l7.14 5.54C43.18 37.26 46.1 31.36 46.1 24.5z"/>
                <path fill="#FBBC05" d="M10.72 28.24A14.6 14.6 0 0 1 9.5 24c0-1.48.25-2.9.72-4.24l-7.08-5.5A23.94 23.94 0 0 0 0 24c0 3.86.92 7.5 2.56 10.74l8.16-6.5z"/>
                <path fill="#34A853" d="M24 47c5.5 0 10.12-1.82 13.5-4.94l-7.14-5.54c-1.98 1.34-4.52 2.13-6.36 2.13-6.27 0-11.6-4.1-13.48-9.76l-8.16 6.5C7.07 41.52 14.82 47 24 47z"/>
              </svg>
            </GoogleIcon>
            Continuar con Google
          </GoogleBtn>

          <RegisterRow>
            <RegisterText isDarkMode={isDarkMode}>¿No tienes cuenta?</RegisterText>
            <RegisterLink onClick={() => navigate(redirectTo ? `/register?redirect=${redirectTo}` : '/register')}>Registrarse</RegisterLink>
          </RegisterRow>

        </LoginForm>
      </LoginCard>
    </LoginContainer>
  );
}

export default Login;